<!--
 * @Author: 四川华西绿舍建材有限公司
 * @Date: 2023-05-10 11:20:25
 * @LastEditors: hexy
 * @LastEditTime: 2023-05-11 14:16:24
 * @Description: 周期列表
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\monthlyReportList.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="header_right">
          <el-button class="bottom_all_two" @click="goBack">返 回</el-button>
        </div>
        <div class="card" style="margin-top: 30px">
          <div>
            <div style="margin: 10px 50px; font-size: 16px; color: darkgray">
              <span style="margin-left: 15px">上次截止时间：
                <span v-if="recentlyResord.currentDueTime">{{ recentlyResord.currentDueTime || "" }}</span>
                <el-date-picker v-else v-model="lastDueTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
                </span>
              <span style="margin-left: 15px"
                >本次截止时间：
                <el-date-picker v-model="currentDueTime" type="datetime" placeholder="选择日期时间" value-format="yyyy-MM-dd HH:mm:ss" default-time="23:59:59"> </el-date-picker>
              </span>
              <span style="margin-left: 15px"><el-button size="mini" class="bottom_all_two" @click="saveCycleManage">生 成</el-button></span>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info" :style="style">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="tableData" tooltip-effect="dark">
              <el-table-column align="center" label="合同编号" prop="contractCode"></el-table-column>
              <el-table-column align="center" label="合同签订主体" prop="contractSigningSubject"></el-table-column>
              <el-table-column align="center" label="主合同单位" min-width="230" prop="supplierName"></el-table-column>
              <el-table-column align="center" label="上次截止时间" prop="lastDueTime"></el-table-column>
              <el-table-column align="center" label="本次截止时间" prop="currentDueTime"></el-table-column>
              <el-table-column align="center" label="确认状态" prop>
                <template slot-scope="scope">
                  <span>{{ mouthReportStatusList | fromatTable(scope.row.sureStatus, "name", "id") }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link v-if="scope.row.sureStatus == 0" type="success" :underline="false" @click="toConfirm(scope.row, scope.$index)">{{ scope.row.sureStatus == 0 ? "去确认" : "更新" }}</el-link>
                  <el-link v-else type="success" :underline="false" @click="toConfirm(scope.row)">查看</el-link>
                  <el-link v-if="scope.$index == 0 && tableParam.page == 1" type="danger" :underline="false" style="margin-left:10px" @click="deleteCycleManage(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
  </div>
</template>
  <script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPageByMonth, queryRecentlyResord, saveCycleManage, deleteCycleManage } from "@/api/wise/Wise_contactsbusiness/contactPriceList.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  components: {},
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      params: {},
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPageByMonth,
      pagesType: 0,
      mouthReportStatusList: [
        { name: "待确认", id: 0 },
        { name: "已确认", id: 1 },
        { name: "待更新", id: 2 },
      ],
      recentlyResord: {},
      currentDueTime: "",
      lastDueTime:"",
    };
  },
  async created() {
    this.params = JSON.parse(this.$route.query.row);
    this.UserInfo = await getUserInfo();
    this.tableParam = { ...this.tableParam, contractId: this.params.id, dataType: 2 };
    this.gettableData();
    this.queryRecentlyResord();
  },

  methods: {
    deleteCycleManage(row) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteCycleManage({
            id: row.id,
          }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功!");
              this.gettableData();
              this.queryRecentlyResord();
            }
          });
        })
        .catch(() => {});
    },
    saveCycleManage() {
      if (!this.currentDueTime) {
        this.$message.warning("请先选择本次截止时间!");
        return;
      }
      if(!this.recentlyResord && !this.lastDueTime){
        this.$message.warning("请先选择上次截止时间!");
        return;
      }
      this.$confirm("是否确认生成?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          saveCycleManage({
            contractId: this.params.id,
            currentDueTime: this.currentDueTime,
            lastDueTime:this.lastDueTime || this.recentlyResord.currentDueTime
          }).then(res => {
            if (res.code == 1001) {
              this.$message.success("生成成功!");
              this.gettableData();
              this.queryRecentlyResord();
            }
          });
        })
        .catch(() => {});
    },
    queryRecentlyResord() {
      queryRecentlyResord({ contractId: this.params.id, dataType: 2 }).then(res => {
        if (res.code == 1001 && res.data) {
          this.lastDueTime = '';
          this.recentlyResord = res.data;
        }
      });
    },

    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    //   去确认
    toConfirm(row, index) {
      if (row.sureRecentlyPerid == 1) {
        this.$message.warning("请按照时间先后顺序进行确认！");
        return;
      }
      if (index || index == 0) {
        let status = false; //判断是否可以去确认
        if (index == this.tableData.length - 1) {
          status = true;
        } else {
          status = this.tableData[index + 1].sureStatus != 1 ? false : true; //为了调试 true 和false 位置反
        }
        this.tableData.forEach((item, index2) => {
          if (index2 > index && item.sureStatus != 1) {
            status = false;
          }
        });
        if (!status) {
          this.$message.warning("请按照时间先后顺序进行确认！");
          return;
        }
      }
      this.$router.push({ name: "contactRecordList", query: { row: JSON.stringify(row), parentRow: JSON.stringify(this.params),contractTypeId:this.$route.query.contractTypeId } });
    },
    goBack() {
      this.$router.push({ name: "contactUnitRecord" ,query:{contractTypeId:this.$route.query.contractTypeId}});
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.styleA {
  overflow: auto;
  max-height: calc(85vh - 266px);
  padding-right: 10px;
}
.styleB {
  overflow: auto;
  max-height: calc(85vh - 366px);
  padding-right: 10px;
}
.saledialoginfo {
  padding: 20px 20px 0 0px;
  max-height: calc(85vh - 220px);
}
.el-input,
.el-select {
  width: 240px;
}
.top_link {
  color: #008000;
}
.top_link:hover {
  cursor: pointer;
  opacity: 0.7;
}
.table_link {
  margin-left: 10px;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.tabtop {
  width: 378px;
  display: flex;
  border: $bg_color 1px solid;
  border-radius: 4px;
  margin: 20px 20px 0 20px;
  > div {
    height: 40px;
    width: 190px;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    display: flex;
    align-items: center;
    .text {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: $bg_color;
    }
    .active {
      width: 188px;
      @include discen;
      line-height: 40px;
      color: #ffffff;
      background: $bg_color;
      border-radius: 4px;
    }
    .hr {
      height: 20px;
      width: 2px;
      background: $bg_color;
    }
  }
}
.el-input,
.el-select {
  width: 227px;
}
.dialoginfo {
  padding: 0;
}
.form-title {
  font-size: 18px;
  margin: 10px 0;
}
</style>